import React from 'react';
import { IVerifiDocumentComponentProps } from './verify-document.props';
import { IVerifiDocumentComponentState } from './verify-document.state';
import { PDFDocument } from 'pdf-lib'
import { TextField, PrimaryButton, DefaultButton } from "@fluentui/react";
import { $_ } from '../../ioip/sdk/base';
import { PqrWebService } from '../../services/services';
import { ReCaptchaComponent } from '../recaptcha/recaptcha.component';

export class VerifiDocumentComponent extends React.Component<IVerifiDocumentComponentProps, IVerifiDocumentComponentState> {

    private _ref: any;
    private _service: PqrWebService = new PqrWebService();
    private _recaptcha: ReCaptchaComponent;

    constructor(props: any) {
        super(props);
        const match = (this.props as any).match;
        const documentId = match.params.documentId;
        let part1 = '', part2 = '', part3 = '', part4 = '', part5 = '';
        if (!$_.isNullOrEmpty(documentId)) {
            const parts = documentId.split('-');
            if (parts.length === 5) {
                part1 = parts[0];
                part2 = parts[1];
                part3 = parts[2];
                part4 = parts[3];
                part5 = parts[4];
            }

        }
        this.state = {
            documentId: documentId || '',
            documentError: '',
            part1,
            part2,
            part3,
            part4,
            part5,
            reCaptchaToken: '',
            documentLoaded: false
        };

        this.verifyDocumentId = this.verifyDocumentId.bind(this);
    }

    async componentDidMount() {

    }

    render(): JSX.Element {
        return <div className='ms-Grid'>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
                    <h1 className='ms-font-xl ms-fontWeight-semibold'>Verificación de documentos</h1>
                </div>
            </div>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm2'>
                    <TextField
                        placeholder=''
                        maxLength={8}
                        autoFocus={true}
                        ariaLabel=''
                        value={this.state.part1}
                        onChange={(_, part1) => this.setState({ part1 })}
                    />
                </div>
                <div className='ms-Grid-col ms-u-sm1'>
                    <TextField
                        placeholder=''
                        maxLength={4}
                        autoFocus={true}
                        ariaLabel=''
                        value={this.state.part2}
                        onChange={(_, part2) => this.setState({ part2 })}
                    />
                </div>
                <div className='ms-Grid-col ms-u-sm1'>
                    <TextField
                        placeholder=''
                        maxLength={4}
                        autoFocus={true}
                        ariaLabel=''
                        value={this.state.part3}
                        onChange={(_, part3) => this.setState({ part3 })}
                    />
                </div>
                <div className='ms-Grid-col ms-u-sm1'>
                    <TextField
                        placeholder=''
                        maxLength={4}
                        autoFocus={true}
                        ariaLabel=''
                        value={this.state.part4}
                        onChange={(_, part4) => this.setState({ part4 })}
                    />
                </div>
                <div className='ms-Grid-col ms-u-sm7'>
                    <TextField
                        placeholder=''
                        maxLength={12}
                        autoFocus={true}
                        ariaLabel=''
                        value={this.state.part5}
                        onChange={(_, part5) => this.setState({ part5 })}
                    />
                </div>
            </div>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
                    <ReCaptchaComponent
                        onInitialize={component => {
                            this._recaptcha = component;
                            setTimeout(this._recaptcha.initialize, 2000);
                        }}
                    />
                </div>
            </div>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
                    <small style={{ color: 'red' }}>{this.state.documentError}</small>
                    <PrimaryButton
                        text='Verificar'
                        onClick={this.verifyDocumentId.bind(this)}
                    />
                </div>
            </div>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
                    <iframe
                        id="pdf"
                        style={{ width: '100%', height: '600px' }}
                        ref={e => this._ref = e}
                    ></iframe>
                </div>
            </div>
            <div className='ms-Grid-row'>
                <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
                    <DefaultButton
                        text='Volver a inicio'
                        href='#/home'
                    />
                </div>
            </div>
        </div>
    }

    private async verifyDocumentId() {
        const resultCaptcha = this._recaptcha.isValid();
        if (resultCaptcha.isCaptchaValid === false) {
            this.setState({
                documentError: 'Debe completar la validación de seguridad'
            });
            return;
        }
        else {
            let documentId = this.state.documentId;
            if ($_.isNullOrEmpty(documentId)) {
                documentId = this.state.part1 + '-' + this.state.part2 + '-' + this.state.part3 + '-' + this.state.part4 + '-' + this.state.part5
            }
            try {
                const result = await this._service.getSignaxServerDocumentById(documentId, resultCaptcha.recaptchaToken);
                var file = new Blob([result], { type: 'application/pdf' });
                let blobUrl = URL.createObjectURL(file);
                this._ref.src = blobUrl;
                window.URL.revokeObjectURL(blobUrl);
                this.setState({
                    documentError: '',
                    documentLoaded: true
                });
            }
            catch (error) {
                alert('Se ha producido un error al obtener el documento, por favor verifique que el token sea correcto o recargue la página para diligenciar nuevamente el reCAPTCHA.' + error);
            }
        }
    }

}